<template>
  <div class="task-pool-search-results">
    <div class="selector-buttons">
      <div class="selector-holder">
        <div v-show="loading_clients">
          <i class="fa fa-sync fa-spin"></i>
        </div>
        <div v-show="!loading_clients" class="selector" @click="switchSelector('clients')" :class="{'selected': selector === 'clients'}">Clients
          <div class="sec">{{ clients ? clients.length : 0 }}</div>
        </div>
      </div>
      <div class="selector-holder">
        <div v-show="loading_projects">
          <i class="fa fa-sync fa-spin"></i>
        </div>
        <div v-show="!loading_projects" class="selector" @click="switchSelector('projects')" :class="{'selected': selector === 'projects'}">Projects
          <div class="sec">{{ project_map ? project_map.total : 0 }}</div>
        </div>
      </div>
      <div class="selector-holder">
        <div v-show="loading_tasks">
          <i class="fa fa-sync fa-spin"></i>
        </div>
        <div v-show="!loading_tasks" class="selector" @click="switchSelector('tasks')" :class="{'selected': selector === 'tasks'}">Tasks
          <div class="sec">{{ task_map ? task_map.total : 0 }}</div>
        </div>
      </div>
    </div>

    <div class="results">

      <!--CLIENTS-->
      <div class="client-results" v-if="selector === 'clients' && clients">
        <div class="clients">
          <div class="client" v-for="client in clients">
            <div class="client-name pointer" @click="changeView('client', client)">
              <div class="name subheading">{{ client.name }}</div>
              <div class="expand">
                <i class="fas fa-chevron-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--PROJECTS-->
      <div class="project-results" v-if="selector == 'projects' && project_map">
        <div class="header">Ongoing</div>
        <div class="client" v-for="client in project_map.ongoing.clients" v-if="project_map.ongoing">
          <div class="name">In {{ client.name }}</div>
          <div class="projects">
            <div class="project" v-for="project in client.projects">
              <div class="project-name pointer">
                <div class="name subheading" @click="changeView('project', project)">{{ project.name }}</div>
                <div class="expand">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="header">Completed</div>
        <div class="client" v-for="client in project_map.done.clients" v-if="project_map.done">
          <div class="name">In {{ client.name }}</div>
          <div class="projects">
            <div class="project" v-for="project in client.projects">
              <div class="project-name pointer">
                <div class="name subheading" @click="changeView('project', project)">{{ project.name }}</div>
                <div class="expand">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="header">Billed</div>
        <div class="client" v-for="client in project_map.billed.clients" v-if="project_map.billed">
          <div class="name">In {{ client.name }}</div>
          <div class="projects">
            <div class="project" v-for="project in client.projects">
              <div class="project-name pointer">
                <div class="name subheading" @click="changeView('project', project)">{{ project.name }}</div>
                <div class="expand">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--TASKS-->
      <div class="task-results" v-if="selector == 'tasks' && task_map">
        <div class="header">Ongoing</div>
        <div class="project" v-for="project in task_map.ongoing.projects">
          <div class="name">In {{ project.name }}</div>
          <div class="tasks">
            <div class="task" v-for="task in project.tasks">
              <div class="task-name pointer">
                <div class="name subheading" @click="showTask(task)">{{ task.name }}</div>
                <div class="expand">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="header">Completed</div>
        <div class="project" v-for="project in task_map.done.projects">
          <div class="name">In {{ project.name }}</div>
          <div class="tasks">
            <div class="task" v-for="task in project.tasks">
              <div class="task-name pointer">
                <div class="name subheading" @click="showTask(task)">{{ task.name }}</div>
                <div class="expand">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";

export default {
  created() {
    this.$root.$on('SearchResults::query', query => {
      this.query = query
    })
    this.$root.$on('ManagerFilter::selected-manager', manager => {
      this.selected_manager = manager
      this.search()
    })
  },
  data() {
    return {
      query: null,
      clients: null,
      project_map: null,
      task_map: null,
      selector: 'clients',
      results: null,
      selected_manager: null,
      loading_clients: false,
      loading_projects: false,
      loading_tasks: false,
      prev_query_value: null
    }
  },
  watch: {
    query: function (value) {
      if (value && value.length < 3) {
        return
      }
      if (!this.prev_query_value) {
        this.loading_clients = true
        this.loading_projects = true
        this.loading_tasks = true
      }
      this.prev_query_value = value
      this.searchDebounced()
    }
  },
  methods: {
    searchDebounced: _.debounce(function () {
      this.search()
    }, 300),
    search() {
      if (!this.query) {
        this.clear()
        return
      }

      this.searchClients()
      this.searchProjects()
      this.searchTasks()
    },
    searchClients() {
      let params = {
        manager_id: this.selected_manager ? this.selected_manager.id : null,
        query: this.query,
        raw: true,
      }
      this.loading_clients = true
      return this.axios.get('/clients', {params}).then(response => {
        this.clients = response.data.data
        this.updateSelector()
      }).finally(() => {
        this.loading_clients = false
      })
    },
    searchProjects() {
      let params = {
        manager_id: this.selected_manager ? this.selected_manager.id : null,
        query: this.query,
      }
      this.loading_projects = true
      return this.axios.get('/n/projects/tasks-pool-search', {params}).then(response => {
        this.project_map = response.data.data
        this.updateSelector()
      }).finally(() => {
        this.loading_projects = false
      })
    },
    searchTasks() {
      let params = {
        manager_id: this.selected_manager ? this.selected_manager.id : null,
        query: this.query,
      }
      this.loading_tasks = true
      return this.axios.get('/n/tasks/task-pool-search', {params}).then(response => {
        this.task_map = response.data.data
        this.updateSelector()
      }).finally(() => {
        this.loading_tasks = false
      })
    },
    clear() {
      this.clients = null
      this.project_map = null
      this.task_map = null
    },
    changeView(view, entity) {
      //view = client | project

      if (view === 'client') {
        this.$tpNav.showProjectList(entity)
      }
      if (view === 'project') {
        this.$tpNav.showProjectView(entity)
      }

    },
    showTask(task) {
      this.$root.$emit('TaskModal::show-task', {parent_id: task.id})
    },
    updateSelector() {
      if (this.selector === 'clients' && this.clients && this.clients.length > 0) {
        return
      }
      if (this.selector === 'projects' && this.project_map && this.project_map.total > 0) {
        return
      }
      if (this.selector === 'tasks' && this.task_map && this.task_map.total > 0) {
        return
      }

      if (this.clients && this.clients.length > 0) {
        this.selector = 'clients'
        return
      }
      if (this.project_map && this.project_map.total > 0) {
        this.selector = 'projects'
        return
      }
      if (this.task_map && this.task_map.total > 0) {
        this.selector = 'tasks'
        return
      }
    },
    switchSelector(to) {
      if (to === 'clients' && (!this.clients || this.clients.length === 0)) {
        return
      }
      if (to === 'projects' && (!this.project_map || this.project_map.total === 0)) {
        return
      }
      if (to === 'tasks' && (!this.task_map || this.task_map.total === 0)) {
        return
      }

      this.selector = to
    }
  }
}
</script>
<style lang="scss">
.task-pool-search-results {

  background: white !important;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 6;
  width: 100%;

  .header {
    padding: 8px 16px;
    color: #999999;
    font-size: 10px;
  }

  .clients {
    .client {
      .client-name {
        display: flex;
        cursor: pointer;
        padding: 8px 16px;

        &:hover {
          background: #F2F2F2;
        }

        .name {
          color: #2F2F2F;
          flex-grow: 1;
        }
      }
    }
  }

  .project-results {
    .divider {
      margin-top: 8px;
      margin-bottom: 8px;
    }

    .client {
      .name {
        padding: 8px 16px 0px;
        color: #999999;
        font-size: 10px;
      }

      .projects {
        .project {
          .project-name {
            display: flex;
            cursor: pointer;
            padding: 8px 16px;

            &:hover {
              background: #F2F2F2;
            }

            .name {
              color: #2F2F2F;
              flex-grow: 1;
              padding: 0;
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  .task-results {
    .divider {
      margin-top: 8px;
      margin-bottom: 8px;
    }

    .project {
      .name {
        padding: 8px 16px 0px;
        color: #999999;
        font-size: 10px;
      }

      .tasks {
        .task {
          .task-name {
            display: flex;
            cursor: pointer;
            padding: 8px 16px;

            &:hover {
              background: #F2F2F2;
            }

            .name {
              color: #2F2F2F;
              flex-grow: 1;
              padding: 0;
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  .selector-buttons {
    width: 100%;
    display: flex;
    padding: 24px;

    .selector-holder {
      flex-basis: 33%;
      margin: 0 2px;
      display: flex;
      align-items: center;
      justify-content: center;

      .selector {
        text-align: center;
        cursor: pointer;
        color: #2F2F2F;
        border-radius: 32px;
        width: fit-content;
        padding: 4px 10px;
        display: flex;

        &.selected {
          background: #2F2F2F;
          color: #FFFFFF;
        }

        &:hover:not(.selected) {
          background: #F2F2F2;
        }

        .sec {
          color: #B3B3B3;
          margin-left: 4px;
        }

      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/views/agenda-v2/task-pool/search/search-results.vue